import { Route, Routes, Navigate, useLocation } from "react-router-dom";
import React, { memo } from "react";
import SubscriptionPlan from "../screens/Subscription/SubscriptionPlan";
import SubscriptionCancel from "../screens/Subscription/SubscriptionCancel";
import { useSelector, useDispatch } from "react-redux";
import {
  LoginState,
  accountActions,
  getAccountState,
} from "../redux/slices/accountSlice";
import SubscriptionFreeze from "../screens/Subscription/SubscriptionFreeze";
import { NavigationId } from "../navigation/AppParamList";

const SubscriptionRoute = memo(function SubscriptionRouteFn() {
  const { account } = useSelector(getAccountState);
  const { loggedIn } = account;
  const dispatch = useDispatch();
  const { pathname } = useLocation();

  if (loggedIn === LoginState.LOGGED_IN) {
    return (
      <Routes>
        <Route index element={<SubscriptionPlan />} />
        <Route path="cancel" element={<SubscriptionCancel />} />
        <Route path="freeze" element={<SubscriptionFreeze />} />
      </Routes>
    );
  } else {
    dispatch(accountActions.setRedirectPath(pathname));
    return <Navigate to={NavigationId.WELCOME} />;
  }
});

export default SubscriptionRoute;
